<!-- Action Button Item Wrapper -->
<div class="fuse-vertical-navigation-item-wrapper my-2 px-4" [ngClass]="item.classes?.wrapper">
  <!-- Action Button with function -->
  @if (!item.link && item.function && !item.disabled) {
    @if (navCollapsed) {
      <!-- Colapsado: botón circular icon-only NATIVO de Material (matIconButton).
        Centra el ícono solo, sin pelear con los internals MDC del stroked button. -->
      <button
        mat-icon-button
        class="fuse-vertical-navigation-action-button bp-action-fab text-white"
        [attr.aria-label]="item.title"
        [matTooltip]="navTooltip"
        [matTooltipDisabled]="!navTooltip"
        matTooltipPosition="right"
        (click)="item.function(item)"
      >
        @if (item.icon) {
          <mat-icon
            class="text-white"
            [ngClass]="item.classes?.icon"
            [svgIcon]="item.icon"
          ></mat-icon>
        }
      </button>
    } @else {
      <button
        mat-stroked-button
        class="w-full fuse-vertical-navigation-action-button gap-3"
        [matTooltip]="navTooltip"
        [matTooltipDisabled]="!navTooltip"
        matTooltipPosition="right"
        (click)="item.function(item)"
        >
        <!-- Icon -->
        @if (item.icon) {
          <mat-icon
            class="fuse-vertical-navigation-item-icon"
            [ngClass]="item.classes?.icon"
            [svgIcon]="item.icon"
          ></mat-icon>
        }

        <!-- Title & Subtitle -->
        <div class="fuse-vertical-navigation-item-title-wrapper">
          <div class="fuse-vertical-navigation-item-title">
            <span>{{ item.title }}</span>
          </div>
          @if (item.subtitle) {
            <div class="fuse-vertical-navigation-item-subtitle">
              <span>{{ item.subtitle }}</span>
            </div>
          }
        </div>

        <!-- Badge -->
        @if (item.badge) {
          <div class="fuse-vertical-navigation-item-badge" [ngClass]="item.badge.classes">
            @switch (true) {
              @case (!!item.badge.title) {
                <div class="fuse-vertical-navigation-item-badge-content">
                  {{ item.badge.title }}
                </div>
              }
            }
          </div>
        }
      </button>
    }
  }

  <!-- Disabled Action Button -->
  @if (item.disabled) {
    <button
      mat-flat-button
      color="primary"
      class="w-full fuse-vertical-navigation-action-button"
      [matTooltip]="navTooltip"
      [matTooltipDisabled]="!navTooltip"
      matTooltipPosition="right"
      [disabled]="true"
      >
      <!-- Icon -->
      @if (item.icon) {
        <mat-icon
          class="fuse-vertical-navigation-item-icon"
          [ngClass]="item.classes?.icon"
          [svgIcon]="item.icon"
        ></mat-icon>
      }

      <!-- Title & Subtitle -->
      <div class="fuse-vertical-navigation-item-title-wrapper">
        <div class="fuse-vertical-navigation-item-title">
          <span>{{ item.title }}</span>
        </div>
        @if (item.subtitle) {
          <div class="fuse-vertical-navigation-item-subtitle">
            <span>{{ item.subtitle }}</span>
          </div>
        }
      </div>

      <!-- Badge -->
      @if (item.badge) {
        <div class="fuse-vertical-navigation-item-badge" [ngClass]="item.badge.classes">
          @switch (true) {
            @case (!!item.badge.title) {
              <div class="fuse-vertical-navigation-item-badge-content">
                {{ item.badge.title }}
              </div>
            }
          }
        </div>
      }
    </button>
  }
</div>
